import React from 'react';
import ReactDOM from 'react-dom';
import App from './routes/App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { APP_THEME } from './styles/theme/styled/theme';
import './styles/app.scss';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/animations/perspective.css';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${APP_THEME.typography.body};    
  }
`;

ReactDOM.render(
  // <React.StrictMode>
  <ThemeProvider theme={APP_THEME}>
    <GlobalStyle />
    <App />
  </ThemeProvider>,
  // </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
